<template>
	<div>
		<a-layout>
			<a-layout-sider style="background: #FFFFFF;overflow: hidden; height: 100vh;" width="200px">
				<div style="padding: 30px 20px;">
					<div v-for="(item,index) in menus" :key="index" @click="goToUrl(index)" class="second-menu-item "
						:class="{on:getSelectKey.indexOf(item.key) > -1}">
						<i class="iconfont ft14" :class="item.icon"></i>
						<span class="ft14 ml10">{{item.name}}</span>
					</div>
				</div>
			</a-layout-sider>
			<a-layout-content style="padding: 30px 20px;height: 100vh; background: #F7F8FA;">
				<div>
					<router-view></router-view>
				</div>
			</a-layout-content>
		</a-layout>

	</div>
</template>

<script>
	export default {

		data() {
			return {
				showForm: false,
				isMulti: false,
				menus: [
					// {
					// 	name: '账号管理',
					// 	icon: 'iconadminister',
					// 	key: 'setting_account',
					// 	link: '/account'
					// },
					{
						name: '菜单管理',
						icon: 'iconhome_nav05',
						key: 'setting_sysmenu',
						link: '/sysmenu'
					},
					{
						name: '角色管理',
						icon: 'iconhome_nav05',
						key: 'setting_sysrole',
						link: '/sysrole'
					},
					// {
					// 	name: '店铺资料',
					// 	icon: 'iconshop',
					// 	key: 'setting_shop',
					// 	link: '/setting/shop'
					// },
					// {
					// 	name: '店铺认证',
					// 	icon: 'iconverification',
					// 	key: 'setting_auth',
					// 	link: '/setting/auth'
					// },
					// {
					// 	name: '短信设置',
					// 	icon: 'iconmsg',
					// 	key: 'setting_sms',
					// 	link: '/setting/sms'
					// },
					{
						name: '积分设置',
						icon: 'iconintegral',
						key: 'setting_integral',
						link: '/setting/integral'
					},
					{
						name: '余额设置',
						icon: 'iconmoney_setting',
						key: 'setting_balance',
						link: '/setting/balance'
					},
					// {
					// 	name: '买单设置',
					// 	icon: 'iconmaidan_setting',
					// 	key: 'setting_buy',
					// 	link: '/setting/buy'
					// },
					// {
					// 	name: '打印机设置',
					// 	icon: 'iconappoint_tab08',
					// 	key: 'setting_printer',
					// 	link: '/setting/printer'
					// },
				],
			}
		},
		computed: {
			/*getMenus() {
				let newMenus = new Array;
				for (var a in this.menus) {
					newMenus.push(this.menus[a]);
					if (a == 0) {
						if (this.isMulti) {
							newMenus.push({
								name: '门店管理',
								icon: 'iconhome_nav05',
								key: 'setting_mendian',
								link: '/mendian'
							});
						}
					}
				}
				return newMenus;
			}*/
		},
		created() {
			this.filterMenusByPermission();
			this.checkMendian();
		},
		methods: {
			filterMenusByPermission() {
				// 获取权限字符串
				const caidanStr = localStorage.getItem('beautiful-caidan');
				if(caidanStr == 'all'){
					return;
				}
				const allowedKeys = caidanStr.split(',');
				
				// 过滤菜单
				this.menus = this.menus.filter(menu => 
					allowedKeys.includes(menu.key)
				);
        	},
			checkMendian() {
				this.$http.api('admin/getShopMendianSetting').then(res => {
					this.isMulti = res.is_multi == 1 ? true : false;
				}).catch(res => {

				})
			},
			goToUrl(index) {
				console.log('goToUrl',index);
				// this.refreshPage(this.getMenus[index].link);
				this.refreshPage(this.menus[index].link);
			},


		}
	}
</script>

<style>

</style>
